
(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/utils/timePeriod.js'),
            require('../modules/formatter.js'),
            require('../enums/metrics.js'),
            require('../modules/data/channels.js'),
            require('../modules/utils/sort.js'),
            require('d3'),
            require('lodash'),
            require('underscore.string')
        );

    } else {
        RivalIQ.metrics.defaults = exportFn(
            RivalIQ.utils.timePeriod,
            RivalIQ.formatter,
            RivalIQ.enums,
            RivalIQ.data.channels,
            RivalIQ.utils.sort,
            window.d3,
            window._,
            window.s
        );
    }

    function exportFn(timePeriodUtils, formatter, metricEnums, channels, sort, d3, _, s) {
        const colorScale = d3.scale.category10().domain(d3.range(0, 10));

        const metricDefaults = {
            format: function (data, metric, options) {
                return metric.defaultFormat(data, options);
            },
            type: metricEnums.dataType.INTEGER,
            metricType: metricEnums.metricType.VOLUME,
            hasHistory: true,
            csvFormat: _.identity,
            missingDataFormat: '--',
            emptyStringFormat: '',
            domainRange: function (data) {
                return [0, data.length];
            },
            source: function (data, metric) {

                const source = metric.source;
                if (!_.isUndefined(source)) {
                    const channelFromSource = channels.get(source);
                    if (channelFromSource && channelFromSource.get('channel') === metric.channel) {
                        return source;
                    }
                }

                const channel = channels.get(metric.channel);
                // NOTE handle deprecated channels
                return (channel ? channel.id : null);
            },
            name: function (value, metric) {
                if (metric.property === 'name') {
                    return s.titleize(_.last(metric.dimensions));
                }

                return s.titleize(metric.property);
            },
            color: function (value) {
                // Hash the value to generate a consistent color
                const hash = _.reduce(value, function (val, c) {
                    return val * (String(c)).charCodeAt(0);
                }, 7);

                return colorScale(hash % 10);
            },
            sort: function (value, metric) {
                if (metric.getMetricType() === metricEnums.metricType.TEXT) {
                    return sort.text;
                }

                return sort.default;
            },
            collection: metricEnums.collection.GENERAL
        };

        const dimensionDefaults = _.extend({}, metricDefaults, {
            format: _.identity
        });

        return {
            metric: metricDefaults,
            dimension: dimensionDefaults
        };
    }
})();
